import Navbar from '@/components/Navbar'

export const about = [{
    path: '/about',
    redirect: '/about/structure',
    component: Navbar,
    children: [{
            path: '/about/structure',
            meta: {
                title: '关于大奖-未来科学大奖'
            },
            component: () =>
                import ('@/views/about/structure'),
        },
        {
            path: '/about/contact',
            meta: {
                title: '关于大奖-未来科学大奖'
            },
            component: () =>
                import ('@/views/about/contact'),
        },
        {
            path: '/about/oversight',
            meta: {
                title: '关于大奖-未来科学大奖'
            },
            component: () =>
                import ('@/views/about/oversight'),
        },
        {
            path: '/about/regulations',
            meta: {
                title: '关于大奖-未来科学大奖'
            },
            component: () =>
                import ('@/views/about/regulations'),
        },
        {
            path: '/about/science',
            meta: {
                title: '关于大奖-未来科学大奖'
            },
            component: () =>
                import ('@/views/about/science'),
        },
    ],
}, ]